import { redirectToEhmp } from '~globals/common';

import { getUrlParam } from './common';

interface ISessionParameters {
    pathname: string;
    trackingParams: object;
    allid: string;
    zip: string;
    leadToken: string;
    countyName: string;
    ntmVisited: string[];
    sessionCode: string;
}

/**
 * Redirects returning visitor to quote page
 *
 * @param hasVisitedQuotePage
 * @param sessionParameters
 * @returns
 */
export function redirectReturningVisitor(
    hasVisitedQuotePage: string,
    sessionParameters: ISessionParameters
): boolean {
    if (hasVisitedQuotePage !== 'true') return false;

    if (!isRedirectReturningVisitorCandidate(sessionParameters)) {
        return false;
    }

    // redirect to EHMP
    redirectToEhmp({
        ...sessionParameters.trackingParams,
        allid: sessionParameters.allid,
        zip: sessionParameters.zip,
        leadToken: sessionParameters.leadToken,
        county: sessionParameters.countyName,
        action: 'redirect_with_zip_code',
        lastV1Action: 'quoteFromV1',
        ehimRedirect: true, // use this to signal redirection from EHIM
        uxId: '999', // hard-code user experience ID (999 -- redirected to the quote page)
        ...(sessionParameters.ntmVisited.length > 0 && { n2m: 'true' }),
        ...(sessionParameters.sessionCode && { ppSaveSessionId: sessionParameters.sessionCode }),
    });

    return true;
}

/**
 * Determines whether visitor should be considered for return visitor redirection mechanism
 * Use direct mostly on SSR side to find out if to show spinner or not
 *
 * @param hasVisitedQuotePage
 * @param sessionParameters
 * @returns
 */
export function isRedirectReturningVisitorCandidate(
    sessionParameters: ISessionParameters
): boolean {
    // force all visitors on /enroll/welcome-back/ to be considered as candidates
    if (['/enroll/welcome-back/'].some((path) => sessionParameters.pathname.includes(path))) {
        return true;
    }

    // URL parameter determining if return visitor should be considered for redirection
    const isRedirectToQuote = getUrlParam('returnredirect');
    if (isRedirectToQuote !== 'true') {
        return false;
    }

    // only for visitors landing on these pages
    if (
        !['/enroll/online/', '/enroll/welcome-back/'].some((path) =>
            sessionParameters.pathname.includes(path)
        )
    ) {
        return false;
    }

    return true;
}
